import {useMutation, useQueryClient} from "@tanstack/react-query";
import {saveAccountShipmentInfoApi} from "../../../../../api/correspondent/CorresspondentApi";
import {SearchAccountType} from "../interface";
import {useModal} from "../../../../../hooks";

type Props = {
    setRead: () => void;
};

/**
 * 출하정보 저장
 * @param param0
 * @returns
 */
export const useSaveAccountShipmentInfo = ({setRead}: Props) => {
    const queryClient = useQueryClient();
    const {handleModal} = useModal()

    const {mutate} = useMutation({
        mutationFn: (data: SearchAccountType) => saveAccountShipmentInfoApi(data),
        onSuccess: (res) => {
            const r = res as any

            if (r.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: r.msg,
                    type: "alert",
                    closeAction: () => {
                        console.log("update success", res);
                        setRead();
                        queryClient.invalidateQueries({
                            queryKey: ["readAccountShipmentInfo"],
                        });
                    }
                })
            } else {
                handleModal({
                    isOpen: true,
                    contents: r.msg,
                    type: "alert",
                })
            }
        },
        onError: (error) => {
            console.log("update error", error);
        },
    });

    return {mutate};
};
